module.exports = __webpack_public_path__ + "static/media/image_1.a8c41b83.png";